import { getQueryStrings } from "./support/browser-hacks";
import { getSignedURLsAndNamesForFiles } from "./get-files-for-app-creation";
import type { ImportTableData } from "./firebase-function-types";

export interface SetOrUpdateUsersAppParams {
    readonly prompt: string | undefined;
    readonly filesURLs: readonly ImportTableData[];
}

export async function getSetOrUpdateUsersAppParams(): Promise<SetOrUpdateUsersAppParams> {
    let signedFilesURLs: readonly ImportTableData[] = [];
    const urlFiles = getQueryStrings().get("files")?.split(",") ?? [];
    if (urlFiles.length > 0) {
        signedFilesURLs = await getSignedURLsAndNamesForFiles(urlFiles);
    }

    return {
        prompt: getQueryStrings().get("prompt") ?? undefined,
        filesURLs: signedFilesURLs,
    };
}
